import type { AdminStore, StoreAuditEntry } from '@/client/types/stores';
import { useStoreAuditQuery } from '@/client/api/stores/stores.query';
import { SectionCard, TimelineSkeleton } from './shared';
import { auditActor as actorFor, auditLabel as labelFor, auditReason as reasonFor, auditWhen } from './auditLabels';

const whenFor = (e: StoreAuditEntry): string => auditWhen(e)?.toLocaleString() ?? '';


export const AuditTab: React.FC<{ store: AdminStore }> = ({ store }) => {
  const { data: entries = [], isLoading } = useStoreAuditQuery(store.storeid);
  if (isLoading) return <TimelineSkeleton />;

  return (
    <SectionCard bare description="History of admin actions on this store.">
      {entries.length === 0 ? (
        <p className="py-6 text-center text-sm text-gray-400">No admin actions recorded yet.</p>
      ) : (
        <ol className="relative space-y-4 border-l border-gray-200 pl-5">
          {entries.map((e, i) => {
            const reason = reasonFor(e);
            return (
              <li key={i} className="relative">
                <span className="absolute -left-[23px] top-1 h-2.5 w-2.5 rounded-full bg-teal-500" />
                <div className="flex items-center justify-between gap-4">
                  <span className="text-sm font-medium text-gray-900">{labelFor(e)}</span>
                  <span className="text-xs text-gray-400">{whenFor(e)}</span>
                </div>
                <p className="text-xs text-gray-500">by {actorFor(e)}{reason ? ` — ${reason}` : ''}</p>
              </li>
            );
          })}
        </ol>
      )}
    </SectionCard>
  );
};
